import * as React from "react";

import {Types} from "@Common/types";

type Branch = Types.Apis.Payloads.Next.Branch.GetAll.Response[number];

export const makeBranchAsSublabelMap = ({forInternalUser=false}:{forInternalUser?: boolean} = {}) => (
    (branch:Pick<Branch, "idBranch" | "branchAddress1" | "branchAddress2" | "branchCity" | "branchLinkId" | "branchState" | "branchZip">): JSX.Element => {
        const addressText = [
            branch.branchAddress1,
            branch.branchAddress2,
            branch.branchCity,
            branch.branchState,
            branch.branchZip,
        ].filter(Boolean).join(", ");
        const idsText = [branch.branchLinkId, forInternalUser && `Internal ID: ${branch.idBranch}`].filter(Boolean).join(" | ");

        return (<>
            <div title={addressText}>
                {addressText}
            </div>
            <div
                title={idsText}
                xd-qa-type="dropdown_item"
                xd-qa-name={`Office ${branch.idBranch}`}
            >
                {idsText}
            </div>
        </>);
    }
);
